/* ============================================================
   MONNAIE DU MONDE — global.js
   Carrousels, révélation au scroll, slideshow, texte dynamique,
   tiroir mobile, ajout panier AJAX avec limites, toast.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- toast ---------- */
  var toastTimer = null;
  window.mdmToast = function (html) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('visible'); }, 3200);
  };

  /* ---------- compteur panier ---------- */
  window.mdmMajBulle = function (n) {
    var b = document.getElementById('bulle-panier');
    if (!b) return;
    b.textContent = n;
    b.classList.toggle('visible', n > 0);
  };

  /* ---------- carrousels (flèches) ---------- */
  window.mdmInitCarrousels = function (racine) {
    (racine || document).querySelectorAll('[data-defile]').forEach(function (b) {
      if (b.dataset.lie) return;
      b.dataset.lie = '1';
      b.addEventListener('click', function () {
        var piste = document.getElementById(b.dataset.defile);
        if (!piste) return;
        var carte = piste.querySelector('.carte');
        var pas = (carte ? carte.getBoundingClientRect().width + 22 : 300) * Math.sign(+b.dataset.sens);
        piste.scrollBy({ left: pas, behavior: 'smooth' });
      });
    });
  };

  /* ---------- révélation au scroll (avec garde-fou) ---------- */
  window.mdmInitReveal = function (racine) {
    var els = Array.prototype.slice.call((racine || document).querySelectorAll('.reveal:not(.vu)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vu'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('vu'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('vu'); }); }, 2400);
  };

  /* ---------- ajout panier AJAX (respecte la limite par produit) ---------- */
  function qteEnPanier(varianteId) {
    return fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var ligne = panier.items.find(function (i) { return i.variant_id === +varianteId; });
        return { qte: ligne ? ligne.quantity : 0, total: panier.item_count };
      });
  }

  window.mdmAjouter = function (varianteId, limite, libelleProduit) {
    return qteEnPanier(varianteId).then(function (etat) {
      if (etat.qte >= limite) {
        var msg = (window.mdm.textes.limiteAtteinte || 'Quantité limitée à [limite] — pour des quantités plus importantes, contactez-nous à [email]')
          .replace('[limite]', limite).replace('[email]', window.mdm.emailContact || '');
        window.mdmToast(msg);
        return false;
      }
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: +varianteId, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.mdmMajBulle(etat.total + 1);
        window.mdmToast('' + (window.mdm.textes.ajoutOk || 'Ajouté au panier') +
          (libelleProduit ? ' — ' + libelleProduit : ''));
        return true;
      });
    }).catch(function () {
      window.mdmToast('Une erreur est survenue — réessayez.');
      return false;
    });
  };

  window.mdmInitAjouts = function (racine) {
    (racine || document).querySelectorAll('[data-ajout]').forEach(function (b) {
      if (b.dataset.lie) return;
      b.dataset.lie = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        window.mdmAjouter(b.dataset.ajout, +(b.dataset.limite || 10) || 10);
      });
    });
  };

  /* ---------- menus déroulants (remplacent les <select data-deroulant>) ----------
     Bouton + listbox ARIA : clavier (flèches, Entrée, Échap, Début/Fin),
     clic extérieur, synchronisation du select caché (change dispatché). */
  window.mdmInitDeroulants = function (racine) {
    (racine || document).querySelectorAll('select[data-deroulant]').forEach(function (sel) {
      if (sel.dataset.lie) return;
      sel.dataset.lie = '1';

      var wrap = document.createElement('div');
      wrap.className = 'deroulant';
      sel.parentNode.insertBefore(wrap, sel);
      wrap.appendChild(sel);
      sel.hidden = true;
      sel.setAttribute('aria-hidden', 'true');
      sel.tabIndex = -1;

      var bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'deroulant__bouton';
      bouton.setAttribute('aria-haspopup', 'listbox');
      bouton.setAttribute('aria-expanded', 'false');
      if (sel.getAttribute('aria-label')) bouton.setAttribute('aria-label', sel.getAttribute('aria-label'));

      var libelle = document.createElement('span');
      var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      chevron.setAttribute('class', 'deroulant__chevron');
      chevron.setAttribute('width', '11'); chevron.setAttribute('height', '7');
      chevron.setAttribute('viewBox', '0 0 11 7'); chevron.setAttribute('fill', 'none');
      chevron.innerHTML = '<path d="M1 1l4.5 4.5L10 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
      bouton.appendChild(libelle);
      bouton.appendChild(chevron);

      var panneau = document.createElement('div');
      panneau.className = 'deroulant__panneau';
      panneau.setAttribute('role', 'listbox');

      var options = [];
      Array.prototype.forEach.call(sel.options, function (o, i) {
        if (o.disabled && o.value === '') return; /* placeholder */
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'deroulant__option';
        b.setAttribute('role', 'option');
        b.dataset.valeur = o.value;
        b.dataset.index = i;
        b.innerHTML = '<span>' + o.textContent + '</span><span class="coche">✓</span>';
        b.addEventListener('click', function () { choisir(i); fermer(true); });
        panneau.appendChild(b);
        options.push(b);
      });

      wrap.appendChild(bouton);
      wrap.appendChild(panneau);

      var vise = -1;
      function majLibelle() {
        var o = sel.options[sel.selectedIndex];
        libelle.textContent = o ? o.textContent : '';
        options.forEach(function (b) {
          b.setAttribute('aria-selected', String(+b.dataset.index === sel.selectedIndex));
        });
      }
      function choisir(i) {
        if (sel.selectedIndex === i) return;
        sel.selectedIndex = i;
        majLibelle();
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      function ouvrir() {
        wrap.classList.add('ouvert');
        bouton.setAttribute('aria-expanded', 'true');
        vise = options.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
        viser(vise);
      }
      function fermer(focus) {
        wrap.classList.remove('ouvert');
        bouton.setAttribute('aria-expanded', 'false');
        viser(-1);
        if (focus) bouton.focus();
      }
      function viser(i) {
        vise = i;
        options.forEach(function (b, j) { b.classList.toggle('vise', j === i); });
        if (i >= 0) options[i].focus();
      }
      bouton.addEventListener('click', function () {
        wrap.classList.contains('ouvert') ? fermer(false) : ouvrir();
      });
      wrap.addEventListener('keydown', function (e) {
        var ouvert = wrap.classList.contains('ouvert');
        if (e.key === 'Escape' && ouvert) { e.preventDefault(); fermer(true); }
        else if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') ) {
          e.preventDefault();
          if (!ouvert) { ouvrir(); return; }
          var d = e.key === 'ArrowDown' ? 1 : -1;
          viser((vise + d + options.length) % options.length);
        }
        else if (e.key === 'Home' && ouvert) { e.preventDefault(); viser(0); }
        else if (e.key === 'End' && ouvert) { e.preventDefault(); viser(options.length - 1); }
        else if (e.key === 'Enter' && ouvert && document.activeElement !== bouton) {
          e.preventDefault();
          if (vise >= 0) { choisir(+options[vise].dataset.index); fermer(true); }
        }
        else if (e.key === 'Tab' && ouvert) fermer(false);
      });
      document.addEventListener('pointerdown', function (e) {
        if (wrap.classList.contains('ouvert') && !wrap.contains(e.target)) fermer(false);
      });

      majLibelle();
    });
  };

  /* ---------- slideshow ---------- */
  function initSlideshow(root) {
    var piste = root.querySelector('[data-piste]');
    var points = root.querySelectorAll('[data-point]');
    var n = piste ? piste.children.length : 0;
    if (!piste || n < 2) return;
    var idx = 0, delai = +root.dataset.delai || 6000, timer;
    function aller(i) {
      idx = (i + n) % n;
      piste.style.transform = 'translateX(-' + idx * 100 + '%)';
      points.forEach(function (p, j) { p.classList.toggle('actif', j === idx); });
    }
    function relancer() { clearInterval(timer); timer = setInterval(function () { aller(idx + 1); }, delai); }
    var prec = root.querySelector('[data-prec]'), suiv = root.querySelector('[data-suiv]');
    if (prec) prec.addEventListener('click', function () { aller(idx - 1); relancer(); });
    if (suiv) suiv.addEventListener('click', function () { aller(idx + 1); relancer(); });
    points.forEach(function (p) {
      p.addEventListener('click', function () { aller(+p.dataset.point); relancer(); });
    });
    relancer();
  }

  /* ---------- texte dynamique (défile de HAUT en BAS) ----------
     Markup attendu : pile inversée avec copie du 1er mot en tête ;
     on part du bas de la pile (k = total-1) et k décroît → le texte descend.
     La fenêtre épouse la largeur du mot affiché (au lieu de se caler sur le
     plus long de la liste) : « Monnaie du Monde », le plus courant, reste
     bien centré ; les mots plus longs s'affichent sans être coupés. */
  function initRotateur(defile) {
    var total = defile.children.length;
    if (total < 3 || defile.dataset.lie) return;
    defile.dataset.lie = '1';
    var fenetre = defile.parentElement;
    var k = total - 1, delai = +defile.dataset.delai || 2000;

    function largeurMot(index) {
      var mot = defile.children[index];
      return mot ? Math.ceil(mot.getBoundingClientRect().width) : 0;
    }
    function positionner(animer) {
      defile.style.transition = animer ? 'transform .55s cubic-bezier(.22,.9,.3,1)' : 'none';
      defile.style.transform = 'translateY(' + (-k * 1.18) + 'em)';
      fenetre.style.width = largeurMot(k) + 'px';
    }

    positionner(false);
    setInterval(function () {
      k--;
      positionner(true);
      if (k === 0) { /* copie du 1er mot atteinte : retour invisible en bas de pile */
        setTimeout(function () {
          k = total - 1;
          positionner(false);
        }, 580);
      }
    }, delai);

    /* la largeur des mots dépend d'un font-size en vw : recalcul au redimensionnement */
    var redim;
    window.addEventListener('resize', function () {
      clearTimeout(redim);
      redim = setTimeout(function () { fenetre.style.width = largeurMot(k) + 'px'; }, 120);
    });
  }

  /* ---------- méga-menus : ouverture au survol (brief : sans clic) ----------
     Piloté en JS (.ouvert) plutôt qu'en :hover pur pour fermer proprement
     après un clic sur un lien du panneau ; l'accès clavier reste assuré
     par :focus-within côté CSS. */
  function initNav(racine) {
    (racine || document).querySelectorAll('.nav__item').forEach(function (li) {
      if (li.dataset.lieNav) return;
      li.dataset.lieNav = '1';
      li.addEventListener('mouseenter', function () { li.classList.add('ouvert'); });
      li.addEventListener('mouseleave', function () { li.classList.remove('ouvert'); });
      li.querySelectorAll('.mega a').forEach(function (a) {
        a.addEventListener('click', function () { li.classList.remove('ouvert'); });
      });
    });
  }

  /* ---------- méga-menu Monde : continents → panneau des pays ---------- */
  function initContinents(racine) {
    (racine || document).querySelectorAll('.mega--monde').forEach(function (mega) {
      var boutons = mega.querySelectorAll('.mega__continents button');
      var panneaux = mega.querySelectorAll('.mega__panneau-pays');
      boutons.forEach(function (b) {
        if (b.dataset.lie) return;
        b.dataset.lie = '1';
        b.addEventListener('mouseenter', function () {
          boutons.forEach(function (x) { x.classList.toggle('actif', x === b); });
          panneaux.forEach(function (pn) {
            pn.classList.toggle('actif', pn.dataset.panneau === b.dataset.continent);
          });
        });
      });
    });
  }

  /* ---------- tiroir mobile ---------- */
  function initTiroir() {
    var tiroir = document.getElementById('tiroir-menu');
    if (!tiroir) return;
    document.querySelectorAll('[data-ouvre-tiroir]').forEach(function (b) {
      if (b.dataset.lie) return;
      b.dataset.lie = '1';
      b.addEventListener('click', function () {
        tiroir.classList.add('ouvert');
        tiroir.setAttribute('aria-hidden', 'false');
      });
    });
    tiroir.querySelectorAll('[data-ferme-tiroir]').forEach(function (b) {
      if (b.dataset.lie) return;
      b.dataset.lie = '1';
      b.addEventListener('click', function () {
        tiroir.classList.remove('ouvert');
        tiroir.setAttribute('aria-hidden', 'true');
      });
    });
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    window.mdmInitCarrousels(document);
    window.mdmInitReveal(document);
    window.mdmInitAjouts(document);
    window.mdmInitDeroulants(document);
    initNav(document);
    initContinents(document);
    document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    document.querySelectorAll('[data-rotateur]').forEach(initRotateur);
    initTiroir();
  });

  /* Rafraîchissements de l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) {
    window.mdmInitCarrousels(e.target);
    window.mdmInitReveal(e.target);
    window.mdmInitAjouts(e.target);
    window.mdmInitDeroulants(e.target);
    initNav(e.target);
    initContinents(e.target);
    e.target.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    e.target.querySelectorAll('[data-rotateur]').forEach(initRotateur);
    initTiroir();
  });
})();
